import { portfolio } from "./data/portfolio.js";
import SiteNav from "./components/SiteNav.jsx";
import HeroStage from "./components/HeroStage.jsx";
import ManifestoSection from "./components/ManifestoSection.jsx";
import ProjectRail from "./components/ProjectRail.jsx";
import ExperienceTimeline from "./components/ExperienceTimeline.jsx";
import CapabilityMatrix from "./components/CapabilityMatrix.jsx";
import ContactFinale from "./components/ContactFinale.jsx";
import MotionDirector from "./motion/MotionDirector.jsx";

export default function App() {
  return (
    <MotionDirector>
      <a className="skip-link" href="#main">
        跳到主要内容
      </a>
      <SiteNav sections={portfolio.navigation} />
      <main id="main">
        <HeroStage data={portfolio.hero} profile={portfolio.profile} />
        <ManifestoSection items={portfolio.manifesto} biography={portfolio.profile.biography} />
        <ProjectRail projects={portfolio.projects} />
        <section id="practice" className="practice" aria-labelledby="practice-title">
          <div className="section-kicker section-kicker--dark">
            <span>04 / Practice</span>
            <span>2016—2026</span>
          </div>
          <h2 id="practice-title" className="practice__title">
            TEN YEARS OF
            <span>MAKING SYSTEMS FELT.</span>
          </h2>
          <ExperienceTimeline items={portfolio.experience} />
          <CapabilityMatrix items={portfolio.capabilities} exhibitions={portfolio.exhibitions} />
        </section>
        <ContactFinale
          data={portfolio.contact}
          disclosure={portfolio.disclosure}
          name={portfolio.profile.nameEn}
        />
      </main>
    </MotionDirector>
  );
}
